/* unplugin-vue-components disabled */import script from "./TravelDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./TravelDetails.vue?vue&type=script&setup=true&lang=js"

import "./TravelDetails.vue?vue&type=style&index=0&id=3f516bdb&scoped=true&lang=css"
import "./TravelDetails.vue?vue&type=style&index=1&id=3f516bdb&lang=scss"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f516bdb"]])

export default __exports__